import environment from '@department-of-veterans-affairs/platform-utilities/environment';
import fileUploadUI from 'platform/forms-system/src/js/definitions/file';
import { focusElement } from '@department-of-veterans-affairs/platform-utilities/ui';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-schema.json';
import set from 'platform/utilities/data/set';

import { MAX_FILE_SIZE_BYTES } from '../constants';

export const ancillaryFormUploadUi = (
  label,
  itemDescription,
  {
    attachmentId = '',
    widgetType = 'select',
    customClasses = '',
    isDisabled = false,
    buttonText = '',
    addAnotherLabel = 'Add Another',
    deleteAlertText,
    onUploadError,
  } = {},
) => {
  const findAndFocusLastSelect = () => {
    const uploadList = document.getElementsByClassName('schemaform-file-list');
    const selectField = uploadList[0]?.lastChild?.querySelector('select');
    if (selectField) focusElement(selectField);
  };

  return fileUploadUI(label, {
    itemDescription,
    hideLabelText: !label,
    fileUploadUrl: `${environment.API_URL}/v0/upload_supporting_evidence`,
    buttonText,
    addAnotherLabel,
    deleteAlertText,
    fileTypes: ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'txt'],
    maxSize: MAX_FILE_SIZE_BYTES,
    maxPdfSize: MAX_FILE_SIZE_BYTES,
    minSize: 1,
    createPayload: (file, _formId, password) => {
      const payload = new FormData();
      payload.append('supporting_evidence_attachment[file_data]', file);
      if (password) {
        payload.append('supporting_evidence_attachment[password]', password);
      }
      return payload;
    },
    parseResponse: (response, file) => {
      setTimeout(() => {
        findAndFocusLastSelect();
      });
      return {
        name: file.name,
        confirmationCode: response.data.attributes.guid,
        attachmentId,
      };
    },
    attachmentSchema: ({ fileId }) => ({
      'ui:title': 'File type',
      'ui:disabled': isDisabled,
      'ui:widget': widgetType,
      'ui:options': {
        widgetProps: {
          'aria-describedby': fileId,
        },
      },
    }),
    classNames: customClasses,
    attachmentName: false,
    onUploadError,
  });
};

export const getAttachmentsSchema = defaultAttachmentId => {
  const { attachments } = fullSchema.properties;
  return set(
    'items.properties.attachmentId.default',
    defaultAttachmentId,
    attachments,
  );
};
